<template>
    <div class="broad">
        <div class="box">
            <div class="box_top">
                <div class="box_top_heng"></div>
                {{title?title:'实时播报'}} 
            </div>
            <template v-if="datyy==0">
                <div class="box_cent" v-infinite-scroll="load">
                <el-timeline :reverse="reverse" v-if="eartList.length">
                    <el-timeline-item
                    v-for="(item, index) in eartList"
                    :key="index"
                    :color="index==0?'#4176da':''"
                    :timestamp="item.position+item.magnitude+'级地震'">
                    {{item.upTime}}
                    </el-timeline-item>
                </el-timeline>
                <template v-if="eartList.length==0">
                    <div class="nodata flex justify-center align-center flex-direction">
                        <img src="../../assets/images/empty.png" style="width: 150px;height: 150px;">
                        <div class="" style="font-size: 18px">
                            暂无数据
                        </div>
                    </div>
                </template>
              </div>
            </template>
             <template v-else>
                <div class="box_cent" v-infinite-scroll="load">
                <el-timeline :reverse="reverse"  v-if="eartList.length">
                    <el-timeline-item
                    v-for="(item, index) in eartList"
                    :key="index"
                    :color="index==0?'#4176da':''"
                    :timestamp="item.location?item.location+'发生洪涝':'发生洪涝'">
                    {{item.startYear<10?'0'+item.startYear:item.startYear}}-{{item.startMonth<10?'0'+item.startMonth:item.startMonth}}-{{item.startDay<10?'0'+item.startDay:item.startDay}}
                    </el-timeline-item>
                </el-timeline>
                <template v-if="eartList.length==0">
                    <div class="nodata flex justify-center align-center flex-direction">
                        <img src="../../assets/images/empty.png" style="width: 150px;height: 150px;">
                        <div class="" style="font-size: 18px">
                            暂无数据
                        </div>
                    </div>
                </template>
              </div>
             </template>
        </div>
    </div>
</template>

<script>
export default {
    props: { 
        eartList: {
        type: Array,
        default: []
        },
        title:{
            type: [String,Number],
            default: []
        },
        type:{
            type: [String,Number],
            default: []
        },
        datyy:{
            type: [String,Number],
            default: []
        }
    }, 
     
    data() {
        return{
            load(){
                this.$emit("botchange")
            }
        }
    },
}
</script>
<style >
.broad .el-timeline-item__content{
    font-size: 16px;
    color: #acacac;
}
.broad .el-timeline-item__timestamp{
    color: #242424;
    font-size: 18px;
    line-height: 30px;
}
.broad .box_cent::-webkit-scrollbar{
		width: 7px;
	}
	.broad .box_cent::-webkit-scrollbar-thumb {
		border-radius:10px;
		background: rgba(0, 0, 0, 0.20);
	}
	.broad .box_cent::-webkit-scrollbar-thumb:window-inactive {
		background: rgba(200, 200, 200, 0.4);
	}

</style>
<style scoped>
    .box{
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 0px 43px 0px 
            rgba(115, 119, 125, 0.06);
        border-radius: 12px;
    }
    .box_top{
        display: flex;
        align-items: center;
        height: 70px;
        border-bottom: 1px solid #eee;
        width: 100%;
        font-size: 20px;
        font-weight: 550;
        color: #4176da;
    }
    .box_top_heng{
        width: 5px;
        height: 24px;
        background-color: #4176da;
        border-radius: 2px;
        margin-left: 20px;
        margin-right: 10px;
    }
    .box_cent{
        height: 430px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 35px 0;
        overflow-y: auto;
        padding-right: 20px;
    }
    .box_cet{
        display: flex;
    }
    .box_cet_right_t{
        font-size: 16px;
        color: #acacac;
    }
    .box_cet_right_t1{
        font-size: 18px;
        margin-top: 4px;
    }
    .box_cet_left{

    }
</style>


// WEBPACK FOOTER //
// broadcasting.vue?0bf36afd